import { useMutation } from 'react-query';
import { setAccessToken } from '../axios';
import { getExClientLogin, getToken } from './tokens';

export function useLoginMutation({
  integratedLogin,
  agreementId,
  onSuccess,
  onError,
}: {
  integratedLogin: string;
  agreementId?: string;
  onSuccess: () => void;
  onError: (error: string) => void;
}) {
  return useMutation(
    ({ username, password, idp }: { username: string; password?: string; idp?: string }) =>
      getToken({ username, password, idp, integratedLogin, agreement_id: agreementId }),
    {
      onSuccess: function (data) {
        localStorage.setItem('agreementId', data?.agreement_id?.toString() || agreementId || '');

        setAccessToken(data.token, data.tokenExpirationDate);
        onSuccess();
      },
      onError: function (error: { response?: { data?: { error?: string }, status?: number } }) {
        const status = error?.response?.status;
        if (status === 500) {
          return onError('Erro interno');
        }
        if (error?.response?.data?.error) {
          return onError((error.response as Record<string, Record<string, string>>).data.error as string);
        }
        return onError((error.response as Record<string, Record<string, string>>).data as unknown as string);
      },
    }
  );
}

export function useLoginExClient({ onSuccess, onError }: { onSuccess: () => void; onError: (error: string) => void }) {
  return useMutation(({ cpf }: { cpf: string }) => getExClientLogin({ cpf }), {
    onSuccess: function (data) {
      localStorage.setItem('agreementId', data?.agreement_id?.toString() || '');

      setAccessToken(data.token);
      onSuccess();
    },
    onError: function (error: Record<string, unknown>) {
      const response = error.response as { data: { error?: string } };
      if (response.data.error) {
        onError(response.data.error);
      } else {
        onError(JSON.stringify(response.data));
      }
    },
  });
}
